/* src/app/forms/wizard-configuracao/localdb-type-service/localdb-type-service.component.scss */
/*# sourceMappingURL=localdb-type-service.component.css.map */
